import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Card,
  Divider,
  Box,
  CardMedia,
  Button,
  styled,
  createTheme,
  ThemeProvider
} from '@mui/material';
import moment from 'moment';


const statistiquesAgricultureData = [
  {
    ministere: "Ministère de l'Agriculture, de l'Élevage et de l'Environnement",
    annuaires: "ANNUAIRE DES STATISTIQUES DE L'ENVIRONNEMENT, ÉDITION 2016",
    description: "Les données sur la gestion de l’environnement, l’agriculture durable et l’élevage, soulignant les initiatives mises en place pour la préservation des ressources naturelles.",
    date: "2016-12-31",
    image: 'documents/sectoriels/annuaire2021.png',
    link: "/documents/Sectorials/Annuaire-statistique-de-lenvironement-2016.pdf"
  },
  {
    ministere: "Ministère de l'Agriculture, de l'Élevage et de l'Environnement",
    annuaires: "ANNUAIRE DES STATISTIQUES DE L'ENVIRONNEMENT, ÉDITION 2017",
    description: "Une analyse des tendances en matière d’environnement, agronomie et élevage pour l'année 2017.",
    date: "2017-12-31",
    image: 'documents/sectoriels/annuaire2021.png',
    link: "/documents/Sectorials/Annuaire-statistique-de-lenvironement-2017.pdf"
  }
];

function MinistereAgriculture() {
  const [visibleCount, setVisibleCount] = useState(2); 
  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C'
      },
      background: {
        default: '#f5f5f5'
      }
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C'
      },
      h4: {
        fontWeight: '600'
      }
    }
  });

  const StyledCard = styled(Card)(({ theme }) => ({
    borderRadius: '12px',
    overflow: 'hidden',
    marginBottom: '20px'
  }));

  const handleShowMore = () => {
    setVisibleCount((prevCount) => Math.min(prevCount + 2, statistiquesAgricultureData.length));
  };

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
 
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Ministère de l'Environnement, de l'Agriculture et de l'Elevage
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Le Ministère de l'Agriculture, de l'Élevage et de l'Environnement joue un rôle crucial dans la gestion et la préservation des ressources naturelles. Ce rapport fournit des statistiques importantes concernant l'environnement, l'agriculture durable et l'élevage.
          </Typography>
            {/* Affichage des rapports */}
            {statistiquesAgricultureData.slice(0, visibleCount).map((statistique, index) => (
                      <StyledCard key={index} elevation={1}>
                        <Box sx={{ display: 'flex' }}>
                          <a 
                            href={statistique.link} 
                            style={{ textDecoration: 'none', color: 'inherit' }} 
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <CardMedia
                              component="img"
                              sx={{ width: 71, height: 100, m: 2 }}
                              image={statistique.image} 
                              alt={statistique.annuaires}
                            />
                          </a>
                          <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                            <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                              <a 
                                href={statistique.link} 
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'none', color: 'inherit' }}
                              >
                                {<DownloadIcon />}{statistique.annuaires}
                              </a>
                            </Typography>
                            <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                              {statistique.description}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                              Publié en {moment(statistique.date).format('MMMM YYYY')}
                            </Typography>
                          </Box>
                        </Box>
                      </StyledCard>
                    ))}
   

         
          {visibleCount < statistiquesAgricultureData.length && (
            <Button 
              onClick={handleShowMore} 
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white'
              }}
            >
              Plus de Statistiques
            </Button>
          )}
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default MinistereAgriculture;